export default {"src":"/_next/static/media/patyna_logo_light.e93a0166.svg","height":95,"width":96,"blurWidth":0,"blurHeight":0};